import Loading from "@components/loading/loading";

const ArtifactSidebarLoading = ({ onClose }: { onClose: () => void }) => {
  return (
    <div className="-mt-3 px-6" aria-label="Loading sidebar topic">
      <div className="pt-16">
        <Loading>Loading...</Loading>
      </div>
    </div>
  );
};

export default ArtifactSidebarLoading;
